module.exports = __webpack_public_path__ + "img/qtzj2.d97ccb42.png";